import { configureStore, combineReducers } from "@reduxjs/toolkit";
import pvReducer from "./pvSlice";
import deptReducer from "./deptSlice";
import sideNavReducer from "./sideNavSlice";
import payeeReducer from "./payeeSlice";
import sectionReducer from "./sectionSlice";
import locationReducer from "./locationSlice";
import bankReducer from "./bankSlice";
import projectReducer from "./projectSlice";

import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
    key: "root",
    version: 1,
    storage,
};

const combinedReducer = combineReducers({ 
    pv: pvReducer, 
    dept: deptReducer, 
    sideNav: sideNavReducer,
    payeeRedux: payeeReducer,
    sectionRedux: sectionReducer, 
    locationRedux: locationReducer,
    bankRedux: bankReducer,
    projectRedux: projectReducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'pv/clearVouchers') { // check for action type 
      state = undefined;
    }
    return combinedReducer(state, action);
  };

const persistedReducer = persistReducer(persistConfig, rootReducer);



export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }), 
});

export let persistor = persistStore(store);